module.exports = __webpack_public_path__ + "img/banner.78d67ebd.png";